export const NextHeaders = {
    PATHNAME: 'Next-Custom-Pathname',
    SEARCH: 'Next-Custom-Search',
    LOCALE: 'Next-Custom-Locale',
};
